import type { MessageChannel } from "./types";

export interface ConversationEscalation {
  reason: string | null;
  messageId: string | null;
  channel: MessageChannel | null;
  at: string | null;
}

// Reasons mirror ai-mainframe's escalation detector (CRM-1438).
export const escalationLabel = (reason?: string | null) =>
  reason === "frustration" ? "Sounds frustrated" : "Asked for a person";
